export const ACTION_TYPE = 'actionType';
export const INPUT_TYPE = 'inputType';
export const INPUT_VALUE = 'inputValue';